import { render, staticRenderFns } from "./goodsSkuSupplierSelect.vue?vue&type=template&id=68e86c72&"
import script from "./goodsSkuSupplierSelect.vue?vue&type=script&lang=js&"
export * from "./goodsSkuSupplierSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports